import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'

import { RoutingPaths } from 'app/routes/routes.ts'

import { HotelImage } from 'shared/api/tours/search'
import { Gallery } from 'shared/ui/gallery'
import { HeaderGoBack } from 'shared/ui/header-go-back'

import s from './styles.module.scss'

const TourGallery = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { hotelName, images } = useLocation().state as {
    hotelName: string
    images: HotelImage[]
  }

  if (!hotelName || !images) {
    return (
      <div className={s.container}>
        <HeaderGoBack
          buttonWhite
          variant={'grey'}
          title=""
        />
        <div className={s.empty}>
          <p>{t('tours_block.empty_images')}</p>
        </div>
      </div>
    )
  }

  const onClickImage = (index: number) => {
    navigate(RoutingPaths.tours.preview.path(index), {
      state: {
        hotelName,
        images,
      },
    })
  }

  return (
    <div className={s.container}>
      <HeaderGoBack
        buttonWhite
        variant={'grey'}
        title={hotelName}
      />

      <Gallery
        images={images}
        title={hotelName}
        onClickImage={onClickImage}
      />
    </div>
  )
}

export default TourGallery
